import { defaultFont, dangerColor, whiteColor } from 'assets/jss/material-dashboard-pro-react'
import customDropdownStyle from 'assets/jss/material-dashboard-pro-react/components/customDropdownStyle'

const adminNavbarLinksStyle = (theme) => ({
  ...customDropdownStyle(theme),
  linkText: {
    zIndex: '4',
    ...defaultFont,
    fontSize: '14px',
    margin: '0!important',
    textTransform: 'none',
  },
  buttonLink: {
    position: 'relative',
    marginLeft: '12px',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      margin: '5px 15px 0',
      width: 'auto',
      height: 'auto',
      '& svg': {
        width: '30px',
        height: '24px',
        marginRight: '19px',
        marginLeft: '3px',
      },
      '& .fab,& .fas,& .far,& .fal,& .material-icons': {
        width: '30px',
        fontSize: '24px',
        lineHeight: '30px',
        marginRight: '19px',
        marginLeft: '3px',
      },
    },
    display: 'flex',
    aligniItems: 'flex-end',
  },
  ticketButtonFirst: {
    display: 'block',
    '@media (max-width: 960px)': {
      display: 'none',
    },
  },
  ticketButtonLast: {
    display: 'none',
    '@media (max-width: 960px)': {
      display: 'block',
      marginTop: '20px',
    },
  },
  top: {
    zIndex: '4',
  },
  beforePopper: {
    top: '12px !important',
    left: '-96px !important',
    '&:before': {
      content: '""',
      position: 'absolute',
      borderLeft: '20px solid transparent',
      borderBottom: '20px solid white',
      right: 0,
      top: '-10px',
    },
  },
  links: {
    width: '20px',
    height: '20px',
    zIndex: '4',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: '30px',
      height: '30px',
      color: 'inherit',
      opacity: '0.8',
      marginRight: '16px',
      marginLeft: '-5px',
    },
  },
  notifications: {
    zIndex: '4',
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      top: '5px',
      border: `1px solid ${whiteColor}`,
      right: '5px',
      fontSize: '9px',
      background: dangerColor[0],
      color: whiteColor,
      minWidth: '16px',
      height: '16px',
      borderRadius: '10px',
      textAlign: 'center',
      lineHeight: '14px',
      verticalAlign: 'middle',
      display: 'block',
    },
    [theme.breakpoints.down('sm')]: {
      ...defaultFont,
      fontSize: '14px',
      marginRight: '8px',
    },
  },
  managerClasses: {
    [theme.breakpoints.up('md')]: {
      display: 'inline-block',
    },
  },
  colorSession: {
    color: 'red',
  },
  headerLinksSvg: {
    width: '20px !important',
    height: '20px !important',
  },
  photo: {
    width: '41px !important',
    height: '41px !important',
    overflow: 'hidden',
    marginRight: '11px',
    borderRadius: '50%',
    marginLeft: '10px',
    verticalAlign: 'middle',
    border: '0',
    cursor: 'pointer',
  },
  photoMobile: {
    width: '25px !important',
    height: '25px !important',
    overflow: 'hidden',
    marginRight: '16px',
    borderRadius: '50%',
    marginLeft: '13px',
    verticalAlign: 'middle',
    border: '0',
    cursor: 'pointer',
  },
  anchorPoover: {
    background: '#6064FF',
    color: whiteColor,
    width: 250,
    textAlign: 'left',
  },
  iconProperties: {
    width: 35,
    height: 35,
    fill: theme.palette.white.main,
    margin: '0 5px',
  },
  userLogin: {
    '@media (max-width:959px)': {
      color: theme.palette.primary.black,
    },
    color: theme.palette.white.main,
    width: '100%',
    marginTop: '-10px',
    textAlign: 'end',
  },
  userRole: {
    '@media (max-width:959px)': {
      color: theme.palette.primary.black,
    },
    top: '14px',
    color: theme.palette.white.main,
    position: 'absolute',
    width: '100%',
    paddingRight: '0',
    textAlign: 'end',
  },
  iconStyle: {
    '@media (max-width:959px)': {
      '& svg': {
        fill: 'black',
      },
    },
    width: 55,
    height: 53,
    fill: theme.palette.white.main,
  },
})

export default adminNavbarLinksStyle
